import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  handleLoginRedirect,
  jsonApiHeader,
} from './../../../actions/utilAction';
import { API_URL } from '../../../actions/utilAction';
import { loginActionTypes } from '../../logins/constants/ApiConstants';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  handleLoginRedirect,
  loginActionTypes,
};

export const BUSINESS_NAME_API = `${API_URL}/VerifyBusinessName`;
export const SECURITY_QUESTIONS_POST_API = `${API_URL}/Login/SaveUserSecurityQuestion`;
export const SAVE_LOGIN_QUESTIONS = `${API_URL}/Login/CheckQuestionAnswer`;
export const POST_RESET_SECURITY_QUESTION = `${API_URL}/Login/SendMailToResetSercurityQuestion`;
export const GET_SECURITY_QUESTIONS = `${API_URL}/Login/GetSecurityQuestionForResetToEmail`;
export const securityQuestionsActionType = {
  check_business_name: createRequestActionTypes('CHECK_BUSINESS_NAME'),
  save_login_questions: createRequestActionTypes('SAVE_LOGIN_QUESTIONS'),
  post_reset_security_question: createRequestActionTypes('POST_RESET_SECURITY_QUESTION'),
  get_reset_security_question: createRequestActionTypes('GET_SECURITY_QUESTIONS'),
  remove_error_message: createRequestActionTypes('REMOVE_ERROR_MESSAGE'),
};




// WEBPACK FOOTER //
// ./src/modules/SecurityQuestions/constants/ApiConstants.js